import { render, staticRenderFns } from "./region-tree.vue?vue&type=template&id=5f72f636&scoped=true&"
import script from "./region-tree.vue?vue&type=script&lang=js&"
export * from "./region-tree.vue?vue&type=script&lang=js&"
import style0 from "./region-tree.vue?vue&type=style&index=0&id=5f72f636&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72f636",
  null
  
)

export default component.exports